// Import model
import { CompanyCondition } from '../models/CompanyCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { CompanyIndexedFields } from '../models/CompanyIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { CompanyIndexedFieldsSerializer } from './CompanyIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CompanyCondition - handles JSON serialization and deserialization with type validation
 */
export class CompanyConditionSerializer {
  /**
   * Deserializes a JSON string into a CompanyCondition instance
   */
  static deserialize(json: string): CompanyCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CompanyCondition instance
   */
  static fromObject(obj: any): CompanyCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CompanyCondition');
    }


    const instance: CompanyCondition = {
      fieldName: obj['fieldName'] as CompanyIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CompanyCondition instances
   */
  static deserializeArray(json: string): CompanyCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CompanyCondition instance to a JSON string
   */
  static serialize(instance: CompanyCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CompanyCondition instance to a plain object
   */
  static toObject(instance: CompanyCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of CompanyCondition instances to a JSON string
   */
  static serializeArray(instances: CompanyCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
